import { Header } from 'components/organisms/Header';
import { Footer } from 'components/organisms/Footer';
import { MainContent } from 'components/organisms/MainContent';

export const Home = () => {
  return (
    <>
      <Header />
      <MainContent />
      <Footer />
    </>
  );
};
